import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Link from '../utils/link'
import { Fade } from 'react-reveal'
import { DownCurledArrow, DownCurledLongArrow } from './icons'

const TitleContentImageBlocks = ({ title, items }) => {

  return (
    <section className='tci'>
      <Fade bottom distance='40px'>
        <div className='tci__inner'>
          { title && <h2>{ parse(title) }</h2> }
        </div>
        <div className='tci__items'>
          { items && items.map((item, index) => (
            <div className={`tci__item ${item.widerContent ? 'tci__item--auto' : ''}`} key={ index }>
              { item.image?.localFile &&
              <div className='tci__image'>
                <GatsbyImage image={ item.image.localFile.childImageSharp.gatsbyImageData } alt={ item.title }/>
                <DownCurledArrow color='#FFFFFF'/>
                <DownCurledLongArrow color='#FFFFFF' />
              </div>
              }
              <div className='tci__content'>
                { item.title && <h3>{ parse(item.title) }</h3> }
                { item.content && <div>{ parse(item.content) }</div> }
                { item.button?.url && <Link className='btn' to={ item.button.url }>{ item.button.title }</Link> }
              </div>
            </div>
          )) }
        </div>
      </Fade>
    </section>
  )
}

export default TitleContentImageBlocks